import { Component, OnInit } from '@angular/core';
import { PasswordService } from '../services/password.service';
import { Globals } from 'src/app/shared/services/globals';
import { UserService } from '../services/user.service';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ResponseStatusEnum } from 'src/app/shared/models/system/response-status.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forgetPassword } from 'src/app/shared/models/VM/forgetPasswordVM';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forget-password-form',
  templateUrl: './forget-password-form.component.html',
  styleUrls: ['./forget-password-form.component.css']
})
export class ForgetPasswordFormComponent implements OnInit {
  [x: string]: any;

  submitted: boolean;
  errors: string;
  email;
  restToken;
  newPassword;
  confirmPassword;
  forgetPasswordData:forgetPassword
  constructor( public passwordService: PasswordService,private userService: UserService, private router: Router, public global: Globals,
     private currentRoute: ActivatedRoute, translate: TranslateService,private toastr: ToastrService) {

    translate.setDefaultLang('AR');




   }

  ngOnInit() {
     this.forgetPasswordData=  {Email:"",NewPassword:"",RestToken:""};
      this.restToken = this.currentRoute.snapshot.queryParamMap.get("restToken");
      this.email=this.currentRoute.snapshot.queryParamMap.get("email");
  }


  private markFormGroupTouched(formGroup: NgForm) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }


  ForgetPassword( value : NgForm ) {
    this.submitted = true;
    this.errors = '';
    console.log(this.forgetPasswordData);

    if (value.valid) {
      this.global.spinner= true;
      this.forgetPasswordData.Email=this.email;
      this.forgetPasswordData.RestToken = this.restToken;

      console.log(this.forgetPasswordData);

      this.passwordService.ForgetPassword(this.forgetPasswordData).subscribe(
        (result:any) => {
          console.log(result);
          this.global.spinner= false;
          this.global.Messages = result.messages;
          this.global.status = result.status;

          if (this.global.status == ResponseStatusEnum.OK) {
            this.toastr.success('تم إعادة تعيين كلمة المرور بنجاح.');
            this.router.navigateByUrl("/login");
          }
          else {
            this.errors = this.global.Messages[0].body;
            this.toastr.error(this.global.Messages[0].body);
          }
        }),
        (error) => {
          this.global.spinner= false;
          this.errors = 'ERR' + error;
        };
    }
    else
    {
      this.markFormGroupTouched(value);
    }

  }
}
